import { Component, EventEmitter, Output, signal, ChangeDetectionStrategy } from '@angular/core';
import { debounceTime } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { EMOJIS, TEmojis } from '../../../constants/emojis';
import { TextInput } from '../text-input/text-input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faRotateBackward } from '@fortawesome/pro-solid-svg-icons';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'andor-emoji-picker',
  standalone: true,
  imports: [ReactiveFormsModule, TextInput, FontAwesomeModule],
  templateUrl: './emoji-picker.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './emoji-picker.scss',
})
export class EmojiPicker {
  @Output() selectedEmoji = new EventEmitter<string>();
  filteredEmojis = signal<TEmojis>(EMOJIS);
  searchFormControl = new FormControl('');
  protected readonly faRotateBackward = faRotateBackward;
  constructor() {
    this.searchFormControl.valueChanges
      .pipe(takeUntilDestroyed(), debounceTime(250))
      .subscribe((value) => {
        if (value === null) return;
        const searchValue = this.normalizeString(value);

        // Deep copy of EMOJIS
        if (value.length > 1) {
          const emojis = EMOJIS.map((categories) => {
            const newCategories = { ...categories };
            newCategories.emojis = newCategories.emojis.map((emoji) => {
              return [...emoji];
            });
            return newCategories;
          });

          const filtered = emojis.filter((category) => {
            category.emojis = category.emojis.filter((emoji) => {
              return this.normalizeString(emoji[1]).includes(searchValue);
            });
            return category.emojis.length > 0;
          });
          this.filteredEmojis.set(filtered);
        } else {
          this.filteredEmojis.set(EMOJIS);
        }
      });
  }

  normalizeString(text: string): string {
    return text.trim().toLowerCase();
  }

  reset() {
    this.filteredEmojis.set(EMOJIS);
    this.searchFormControl.patchValue('');
    this.selectedEmoji.emit('');
  }

  selectCategory(id: string, container: HTMLDivElement) {
    container.getElementsByClassName(id)[0].scrollIntoView();
  }
}
